import { BsCreditCard2Front, BsCreditCard2FrontFill } from 'react-icons/bs';
import PropTypes from 'prop-types';

import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import { optimisticInitialState } from '../../../../WeeklyReportTable/reducer/optimisticUIReducer';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';

import styles from './ModifyImputation.module.scss';

/**
 * @typedef Props
 * @property {(action: import('../../../../WeeklyReportTable/reducer/optimisticUIReducer').OptimisticUIActions) => void} handleChangedActions
 * @property {import('../../../../WeeklyReportTable/reducer/optimisticUIReducer').OptimisticUIState} changedActions
 */

/** @param {Props} */
const ModifyImputation = ({ dailyWorkReport, handleChangedActions, changedActions, isWeekly }) => {
  const { activeModifyImputation } = useWorkReportModals();

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Objeto de imputación">
      <div className={`d-flex justify-content-evenly ${styles.container}`}>
        <button
          aria-label="Editar tipo y objeto de imputación"
          className={styles.btn}
          onClick={() =>
            activeModifyImputation({
              dailyWorkReport,
              onAccept: () => {
                handleChangedActions(
                  isWeekly ? { type: 'imputation.weekly' } : { type: 'imputation.daily' }
                );
              }
            })
          }
          type="button"
        >
          {changedActions.iconColor || dailyWorkReport.cambioImputacion ? (
            <BsCreditCard2FrontFill fill={changedActions.iconColor} />
          ) : (
            <BsCreditCard2Front />
          )}
        </button>
      </div>
    </ComponentWithTooltip>
  );
};

export default ModifyImputation;

ModifyImputation.propTypes = {
  changedActions: PropTypes.shape({
    iconColor: PropTypes.string
  }),
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport.isRequired,
  handleChangedActions: PropTypes.func,
  isWeekly: PropTypes.bool
};

ModifyImputation.defaultProps = {
  changedActions: optimisticInitialState,
  handleChangedActions: () => {},
  isWeekly: false
};
